import { toDisplayString as _toDisplayString, createVNode as _createVNode, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, Fragment as _Fragment, resolveComponent as _resolveComponent, withCtx as _withCtx, renderList as _renderList, withScopeId as _withScopeId, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue"
const _withId = /*#__PURE__*/_withScopeId("data-v-105b7390")

_pushScopeId("data-v-105b7390")
const _hoisted_1 = { class: "command-icon-component" }
const _hoisted_2 = {
  key: 0,
  class: "text-none"
}
const _hoisted_3 = {
  key: 1,
  class: "text-none"
}
const _hoisted_4 = { class: "position-relative mt-4" }
const _hoisted_5 = { class: "assign-label" }
const _hoisted_6 = { class: "d-flex flex-wrap mt-2" }
const _hoisted_7 = { class: "text-center mt-3" }
const _hoisted_8 = { class: "text-center mt-3" }
_popScopeId()

export const render = /*#__PURE__*/_withId((_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) => {
  const _component_TabPanel = _resolveComponent("TabPanel")
  const _component_TabView = _resolveComponent("TabView")
  const _component_InlineSvgScoped = _resolveComponent("InlineSvgScoped")

  return (_openBlock(), _createBlock("div", _hoisted_1, [
    (!_ctx.readonly)
      ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
          (_ctx.deviceName)
            ? (_openBlock(), _createBlock("h3", _hoisted_2, _toDisplayString(_ctx.deviceName), 1))
            : _createCommentVNode("", true),
          (_ctx.defaultSettings)
            ? (_openBlock(), _createBlock("strong", _hoisted_3, _toDisplayString(_ctx.defaultSettings.activeLinksLabel), 1))
            : _createCommentVNode("", true)
        ], 64))
      : _createCommentVNode("", true),
    _createVNode("div", _hoisted_4, [
      (!_ctx.readonly)
        ? (_openBlock(), _createBlock(_component_TabView, {
            key: 0,
            activeIndex: _ctx.activeTabIndex,
            "onUpdate:activeIndex": _cache[1] || (_cache[1] = ($event: any) => (_ctx.activeTabIndex = $event)),
            class: "p-tabview--custom position-relative"
          }, {
            default: _withId(() => [
              _createVNode(_component_TabPanel, {
                header: _ctx.$t('AppResource.All')
              }, null, 8, ["header"]),
              _createVNode(_component_TabPanel, {
                header: _ctx.$t('AppResource.Symbols')
              }, null, 8, ["header"]),
              _createVNode(_component_TabPanel, {
                header: _ctx.$t('AppResource.Letters')
              }, null, 8, ["header"]),
              _createVNode(_component_TabPanel, {
                header: _ctx.$t('AppResource.Numbers')
              }, null, 8, ["header"])
            ]),
            _: 1
          }, 8, ["activeIndex"]))
        : _createCommentVNode("", true),
      _createVNode("span", _hoisted_5, _toDisplayString(_ctx.$t(
                        !_ctx.readonly
                            ? "general.assignIcon"
                            : "general.assignedIcon"
                    )), 1),
      _createVNode("div", _hoisted_6, [
        (_openBlock(true), _createBlock(_Fragment, null, _renderList(_ctx.commandIcons, (commandIcon) => {
          return (_openBlock(), _createBlock("div", {
            class: ["command-icon", {
                        selected:
                            _ctx.defaultSettings.selectedCommandIcon === commandIcon,
                        'is-disabled': _ctx.readonly,
                    }],
            key: `commandIcon-${commandIcon}`,
            onClick: ($event: any) => (_ctx.changeIcon(commandIcon))
          }, [
            _createVNode("div", _hoisted_7, [
              _createVNode(_component_InlineSvgScoped, {
                width: 52,
                height: 52,
                src: 
                                    require(`@/assets/images/commandsIcons/${_ctx.getCommandIconFromType(
                                        commandIcon
                                    )}.svg`)
                                ,
                "aria-label": _ctx.CommandIcon[commandIcon]
              }, null, 8, ["src", "aria-label"])
            ]),
            _createVNode("div", _hoisted_8, _toDisplayString(_ctx.CommandIcon[commandIcon].toUpperCase()), 1)
          ], 10, ["onClick"]))
        }), 128))
      ])
    ])
  ]))
})